// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uZzFw","fullView":"styles_fullView__DbdLX"};